(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp-media"] && !Shopify.designMode) return;
  try {
    class LpLazyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.addEventListener('playing', this.onPlaying);
      if (!('IntersectionObserver' in window)) {
        this.play();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) this.play();
            else if (this.video.getAttribute('src')) this.video.pause();
          }
        },
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.video) this.video.removeEventListener('playing', this.onPlaying);
    }

    onPlaying = () => {
      this.setAttribute('data-playing', '');
    };

    play() {
      const video = this.video;
      if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
      video.muted = true;
      const promise = video.play();
      if (promise) promise.catch(() => {});
    }
  }

  if (!customElements.get('lp-lazy-video')) customElements.define('lp-lazy-video', LpLazyVideo);
  } catch(e) { console.error(e); }
})();

})();
